(function(){
  var loadScript = function(url, callback){

    var script = document.createElement("script")
      script.type = "text/javascript";

      if (script.readyState){  //IE
          script.onreadystatechange = function(){
              if (script.readyState == "loaded" ||
                      script.readyState == "complete"){
                        console.log('custom script loaded')
                        script.onreadystatechange = null;
                        callback();
                      }
                    };
                  } else {  //Others
                    script.onload = function(){
                      console.log('custom script loaded')
              callback();
          };
      }

      script.src = url;
      document.getElementsByTagName("head")[0].appendChild(script);

  };

  let updateCartCount = () => {
    let cartCount = $('[data-cart-count');
    if (cartCount.text() === "0") {
      $('#CartCount').removeClass('hide');
      cartCount.text('1')
    } else {
      console.log(parseInt(cartCount.text()))
      console.log(parseInt(cartCount.text()) + 1)
      updatedCount = parseInt(cartCount.text()) + 1;
      cartCount.text(updatedCount);
    }
  }

  var myAppJavaScript = function($){
    $('.add-to-cart-overlay').on('click', () => {

    })
    $(document).on("click",".add-to-cart-btn" ,function(){
      var pid = $(this).data('id');
      var $btn = $(this);
      const preorder_message = $(this).data('preorder');
      const has_recipes = $(this).data('has_recipes');

      console.log('pid: '+pid);

      const data = { quantity: 1, id: parseInt(pid) };

      if (preorder_message) {
        data.properties = { "Preorder": preorder_message };
      }
      data.properties = {...data.properties, ...{ "_has_recipes": has_recipes }};
   
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json', 
        success: function (data) { 
            this.selectors = {
            addToCart: '[data-add-to-cart]',
            addToCartText: '[data-add-to-cart-text]',
            cartCount: '[data-cart-count]',
            cartCountBubble: '[data-cart-count-bubble]',
            cartPopup: '[data-cart-popup]',
            cartPopupCartQuantity: '[data-cart-popup-cart-quantity]',
            cartPopupClose: '[data-cart-popup-close]',
            cartPopupDismiss: '[data-cart-popup-dismiss]',
            cartPopupImage: '[data-cart-popup-image]',
            cartPopupImageWrapper: '[data-cart-popup-image-wrapper]',
            cartPopupImagePlaceholder: '[data-cart-popup-image-placeholder]',
            cartPopupPlaceholderSize: '[data-placeholder-size]',
            cartPopupProductDetails: '[data-cart-popup-product-details]',
            cartPopupQuantity: '[data-cart-popup-quantity]',
            cartPopupQuantityLabel: '[data-cart-popup-quantity-label]',
            cartPopupTitle: '[data-cart-popup-title]',
            cartPopupProperty: '[data-cart-popup-property]',
            cartPopupWrapper: '[data-cart-popup-wrapper]',
            loader: '[data-loader]',
            loaderStatus: '[data-loader-status]',
            quantity: '[data-quantity-input]',
            SKU: '.variant-sku',
            productStatus: '[data-product-status]',
            productForm: '[data-product-form]',
            errorMessage: '[data-error-message]',
            errorMessageWrapper: '[data-error-message-wrapper]',
            productImageWraps: '.product-single__photo',
            productThumbListItem: '.product-single__thumbnails-item',
            productFeaturedImage: '.product-featured-img',
            productThumbsWrapper: '.thumbnails-wrapper',
            shopifyPaymentButton: '.shopify-payment-button',
            priceContainer: '[data-price]',
            regularPrice: '[data-regular-price]',
            salePrice: '[data-sale-price]',
            unitPrice: '[data-unit-price]',
            unitPriceBaseUnit: '[data-unit-price-base-unit]',
            productPolicies: '[data-product-policies]'
        };
          
        this.classes = {
            cartPopupWrapperHidden: 'cart-popup-wrapper--hidden',
            hidden: 'hide',
            visibilityHidden: 'visibility-hidden',
            inputError: 'input--error',
            productOnSale: 'price--on-sale',
            productUnitAvailable: 'price--unit-available',
            productUnavailable: 'price--unavailable',
            productSoldOut: 'price--sold-out',
            cartImage: 'cart-popup-item__image',
            productFormErrorMessageWrapperHidden: 'product-form__error-message-wrapper--hidden',
            activeClass: 'active-thumb'
        };
          
            const btnOriginalContent = $btn.html();
            $btn.html("<div class='message'>Added!</div>");
           setTimeout(function(){
             $btn.html(btnOriginalContent);
            }, 2000);
//             $btn.parent().parent().remove();
            updateCartCount();

            // Envision - disable cart popup when replacement cart drawer is enabled
            if (typeof window.SETTINGS !== 'undefined' && typeof window.SETTINGS.ENABLE_CART_DRAWER !== 'undefined') {
              if (window.SETTINGS.ENABLE_CART_DRAWER == false) {
                this._setupCartPopup(data);
              } else {
                $(document).find('.site-header__cart-toggle').trigger('click');
              }
            } else {
              // this._setupCartPopup(data);
            }

            if (window.location.pathname == '/cart') {
              window.location.reload();
            }
			},_setupCartPopup: function(item) {
            this.$cartPopup = this.$cartPopup || $(this.selectors.cartPopup);
            this.$cartPopupWrapper = this.$cartPopupWrapper || $(this.selectors.cartPopupWrapper);
            this.$cartPopupTitle = this.$cartPopupTitle || $(this.selectors.cartPopupTitle);
            this.$cartPopupProperty = this.$cartPopupProperty || $(this.selectors.cartPopupProperty), 
            this.$cartPopupQuantity = this.$cartPopupQuantity || $(this.selectors.cartPopupQuantity);
            this.$cartPopupQuantityLabel = this.$cartPopupQuantityLabel || $(this.selectors.cartPopupQuantityLabel);
            this.$cartPopupClose = this.$cartPopupClose || $(this.selectors.cartPopupClose);
            this.$cartPopupDismiss = this.$cartPopupDismiss || $(this.selectors.cartPopupDismiss);
            this.$cartPopupImagePlaceholder = this.$cartPopupImagePlaceholder || $(this.selectors.cartPopupImagePlaceholder);
            this._setupCartPopupEventListeners();
            this._updateCartPopupContent(item);
        },
        _updateCartPopupContent: function(item) {
//           if(typeof window.BOLD !== 'undefined'

//              && typeof window.BOLD.common !== 'undefined'

//              && typeof window.BOLD.common.cartDoctor !== 'undefined') {

//             // NOTE: "item" should be the variable containing the item json data from the cart/add.js response

//             item = window.BOLD.common.cartDoctor.fixItem(item);
//           }
             var recurring_desc = "";

            if(item.properties_all  && item.properties_all.frequency_num){

              recurring_desc = "<span> Delivered Every " + item.properties_all.frequency_num + " " + item.properties_all.frequency_type_text + " " + item.properties_all.discounted_price + " each" + "</span>"; 

            }
            var quantity = 1 ;
        
            this.$cartPopupTitle.text(item.product_title);
            this.$cartPopupProperty.html(recurring_desc),
            this.$cartPopupQuantity.text(quantity);
            this.$cartPopupQuantityLabel.text(theme.strings.quantityLabel.replace('[count]', quantity));
            this._setCartPopupPlaceholder(item.featured_image.url, item.featured_image.aspect_ratio);
            this._setCartPopupImage(item.featured_image.url, item.featured_image.alt);
            this._setCartPopupProductDetails(item.product_has_only_default_variant, item.options_with_values, item.properties);
            $.getJSON('/cart.js').then(function(cart) {
//                if(typeof window.BOLD !== 'undefined'

//                  && typeof window.BOLD.common !== 'undefined'

//                  && typeof window.BOLD.common.cartDoctor !== 'undefined') {

//                 // NOTE: "cart" should be the variable containing the cart json data

//                 cart = window.BOLD.common.cartDoctor.fix(cart);

//               }
                this._setCartQuantity(cart.item_count);
                this._setCartCountBubble(cart.item_count);
                this._showCartPopup();
            }
            .bind(this));
        },
        _setupCartPopupEventListeners: function() {
            this.$cartPopupWrapper.on('keyup', function(event) {
                if (event.keyCode === slate.utils.keyboardKeys.ESCAPE) {
                    this._hideCartPopup(event);
                }
            }
            .bind(this));
            this.$cartPopupClose.on('click', this._hideCartPopup.bind(this));
            this.$cartPopupDismiss.on('click', this._hideCartPopup.bind(this));
            $('body').on('click', this._onBodyClick.bind(this));
        },
        _setCartPopupPlaceholder: function(imageUrl, imageAspectRatio) {
            this.$cartPopupImageWrapper = this.$cartPopupImageWrapper || $(this.selectors.cartPopupImageWrapper);
            if (imageUrl === null) {
                this.$cartPopupImageWrapper.addClass(this.classes.hidden);
                return;
            }
            var $placeholder = $(this.selectors.cartPopupPlaceholderSize);
            var maxWidth = 95 * imageAspectRatio;
            var heightRatio = 100 / imageAspectRatio;
            this.$cartPopupImagePlaceholder.css('max-width', maxWidth);
            $placeholder.css('padding-top', heightRatio + '%');
        },
        _setCartPopupImage: function(imageUrl, imageAlt) {
            if (imageUrl === null)
                return;
            this.$cartPopupImageWrapper.removeClass("hide");
            var sizedImageUrl = theme.Images.getSizedImageUrl(imageUrl, '200x');
            var image = document.createElement('img');
            image.src = sizedImageUrl;
            image.alt = imageAlt;
            image.classList.add(this.classes.cartImage);
            image.dataset.cartPopupImage = '';
            image.onload = function() {
                this.$cartPopupImagePlaceholder.addClass(this.classes.hidden);
                this.$cartPopupImageWrapper.append(image);
            }
            .bind(this);
        },
        _setCartPopupProductDetails: function(product_has_only_default_variant, options, properties) {
            this.$cartPopupProductDetails = this.$cartPopupProductDetails || $(this.selectors.cartPopupProductDetails);
            var variantPropertiesHTML = '';
            if (!product_has_only_default_variant) {
                variantPropertiesHTML = variantPropertiesHTML + this._getVariantOptionList(options);
            }
            if (properties !== null && Object.keys(properties).length !== 0) {
                variantPropertiesHTML = variantPropertiesHTML + this._getPropertyList(properties);
            }
            if (variantPropertiesHTML.length === 0) {
                this.$cartPopupProductDetails.html('');
                this.$cartPopupProductDetails.attr('hidden', '');
            } else {
                this.$cartPopupProductDetails.html(variantPropertiesHTML);
                this.$cartPopupProductDetails.removeAttr('hidden');
            }
        },
        _getVariantOptionList: function(variantOptions) {
            var variantOptionListHTML = '';
            variantOptions.forEach(function(variantOption) {
                variantOptionListHTML = variantOptionListHTML + '<li class="product-details__item product-details__item--variant-option">' + variantOption.name + ': ' + variantOption.value + '</li>';
            });
            return variantOptionListHTML;
        },
        _getPropertyList: function(properties) {
            var propertyListHTML = '';
            var propertiesArray = Object.entries(properties);
            propertiesArray.forEach(function(property) {
                if (property[0].charAt(0) === '_')
                    return;
                if (property[1].length === 0)
                    return;
                if (property[0].startsWith('Preorder'))
                  propertyListHTML = propertyListHTML + '<li class="product-details__item product-details__item--property" style="color: #a2252ad4">' + property[1] + '</li>';
                else
                  propertyListHTML = propertyListHTML + '<li class="product-details__item product-details__item--property">' + '<span class="product-details__property-label">' + property[0] + ': </span>' + property[1] + '</li>';
            });
            return propertyListHTML;
        },
        _setCartQuantity: function(quantity) {
            this.$cartPopupCartQuantity = this.$cartPopupCartQuantity || $(this.selectors.cartPopupCartQuantity);
            var ariaLabel;
            if (quantity === 1) {
                ariaLabel = theme.strings.oneCartCount;
            } else if (quantity > 1) {
                ariaLabel = theme.strings.otherCartCount.replace('[count]', quantity);
            }
            this.$cartPopupCartQuantity.text(quantity).attr('aria-label', ariaLabel);
        },
        _setCartCountBubble: function(quantity) {
            this.$cartCountBubble = this.$cartCountBubble || $(this.selectors.cartCountBubble);
            this.$cartCount = this.$cartCount || $(this.selectors.cartCount);
            this.$cartCountBubble.removeClass(this.classes.hidden);
            this.$cartCount.text(quantity);
        },
        _showCartPopup: function() {
            this.$cartPopupWrapper.removeClass(this.classes.cartPopupWrapperHidden);
            this._handleButtonLoadingState(false);
            slate.a11y.trapFocus({
                $container: this.$cartPopupWrapper,
                $elementToFocus: this.$cartPopup,
                namespace: 'cartPopupFocus'
            });
        },
        _hideCartPopup: function(event) {
            var setFocus = event.detail === 0 ? true : false;
            this.$cartPopupWrapper.addClass(this.classes.cartPopupWrapperHidden);
            $(this.selectors.cartPopupImage).remove();
            this.$cartPopupImagePlaceholder.removeClass(this.classes.hidden);
            slate.a11y.removeTrapFocus({
                $container: this.$cartPopupWrapper,
                namespace: 'cartPopupFocus'
            });
            if (setFocus)
                this.$previouslyFocusedElement[0].focus();
            this.$cartPopupWrapper.off('keyup');
            this.$cartPopupClose.off('click');
            this.$cartPopupDismiss.off('click');
            $('body').off('click');
        },
        _onBodyClick: function(event) {
            var $target = $(event.target);
            if ($target[0] !== this.$cartPopupWrapper[0] && !$target.parents(this.selectors.cartPopup).length) {
                this._hideCartPopup(event);
            }
        },
        _handleButtonLoadingState: function(isLoading) {
            if (isLoading) {
                $btn.attr('aria-disabled', true);
            } else {
                $btn.removeAttr('aria-disabled');
            }
        }
         });  
//       $.post("/cart/add", {quantity: 1, id: pid, add: true}, function(data){
//         $btn.parent().html("<div class='message single-item-added'>Added!</div>");
//         $btn.remove();
//       }).then(updateCartCount);
      
    });

  if(!$('body').hasClass('template-product')){
    $(document).on("click",".add-to-cart-image-modal",function(){
      if($(this).parent().find(".overlay-product-options").hasClass("hidden")){
        $(".overlay-product-options").addClass("hidden");
        $(this).parent().find(".overlay-product-options").removeClass("hidden");
        $(this).parent().find(".overlay-product-options").find("li").attr("tabindex", "0");
        $(this).parent().find(".overlay-product-options").find("li").first().focus();
      }
      else{
        $(this).parent().find(".overlay-product-options").addClass("hidden");
        $(this).parent().find(".overlay-product-options").find("li").attr("tabindex", "-1");
      }
      //       $(this).remove();
    });
  }
 
  
//       $(".add-to-cart-image-modal .down_arrow").on("click", function(){
     
//       if($(this).parent().parent().find(".overlay-product-options").hasClass("hidden")){
//         $(".overlay-product-options").addClass("hidden");
//         $(this).parent().parent().find(".overlay-product-options").removeClass("hidden");
//       }
//       else{
//       $(this).parent().parent().find(".overlay-product-options").addClass("hidden");
//       }
// //       $(this).remove();
//     });
  
    $(document).on("click", ".product-recommendations__inner .add-to-cart-image-modal, .add_cart_btn_fix .add-to-cart-image-modal", function(){
    //console.log('hhhh');
    if($(this).parent().find(".overlay-product-options").hasClass("hidden")){
      $(".overlay-product-options").addClass("hidden");
      $(this).parent().find(".overlay-product-options").removeClass("hidden");
    }
    else{
      $(this).parent().find(".overlay-product-options").addClass("hidden");
    }
  });

 
  
  $(document).on("click",".overlay-product-options ul li" ,function(){
    if(!$(this).hasClass("trigger_bis")){
      var pid = $(this).attr('value');
      var $btn = $(this);
      var storehtml = $(this).closest('.overlay-product-options').html();
      var $add_to_cart = $(this).parent().parent().prev();
      const preorder_message = $(this).data('preorder');
      const has_recipes = $(this).data('has_recipes');

      console.log('pid: '+pid);

      const data = { quantity: 1, id: parseInt(pid) };

      if (preorder_message) {
        data.properties = { "Preorder": preorder_message };
      }
      data.properties = {...data.properties, ...{ "_has_recipes": has_recipes }};
   
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json', 
        success: function (data) { 
            this.selectors = {
            addToCart: '[data-add-to-cart]',
            addToCartText: '[data-add-to-cart-text]',
            cartCount: '[data-cart-count]',
            cartCountBubble: '[data-cart-count-bubble]',
            cartPopup: '[data-cart-popup]',
            cartPopupCartQuantity: '[data-cart-popup-cart-quantity]',
            cartPopupClose: '[data-cart-popup-close]',
            cartPopupDismiss: '[data-cart-popup-dismiss]',
            cartPopupImage: '[data-cart-popup-image]',
            cartPopupImageWrapper: '[data-cart-popup-image-wrapper]',
            cartPopupImagePlaceholder: '[data-cart-popup-image-placeholder]',
            cartPopupPlaceholderSize: '[data-placeholder-size]',
            cartPopupProductDetails: '[data-cart-popup-product-details]',
            cartPopupQuantity: '[data-cart-popup-quantity]',
            cartPopupQuantityLabel: '[data-cart-popup-quantity-label]',
            cartPopupTitle: '[data-cart-popup-title]',
            cartPopupProperty: '[data-cart-popup-property]',
            cartPopupWrapper: '[data-cart-popup-wrapper]',
            loader: '[data-loader]',
            loaderStatus: '[data-loader-status]',
            quantity: '[data-quantity-input]',
            SKU: '.variant-sku',
            productStatus: '[data-product-status]',
            productForm: '[data-product-form]',
            errorMessage: '[data-error-message]',
            errorMessageWrapper: '[data-error-message-wrapper]',
            productImageWraps: '.product-single__photo',
            productThumbListItem: '.product-single__thumbnails-item',
            productFeaturedImage: '.product-featured-img',
            productThumbsWrapper: '.thumbnails-wrapper',
            shopifyPaymentButton: '.shopify-payment-button',
            priceContainer: '[data-price]',
            regularPrice: '[data-regular-price]',
            salePrice: '[data-sale-price]',
            unitPrice: '[data-unit-price]',
            unitPriceBaseUnit: '[data-unit-price-base-unit]',
            productPolicies: '[data-product-policies]'
        };
          
        this.classes = {
            cartPopupWrapperHidden: 'cart-popup-wrapper--hidden',
            hidden: 'hide',
            visibilityHidden: 'visibility-hidden',
            inputError: 'input--error',
            productOnSale: 'price--on-sale',
            productUnitAvailable: 'price--unit-available',
            productUnavailable: 'price--unavailable',
            productSoldOut: 'price--sold-out',
            cartImage: 'cart-popup-item__image',
            productFormErrorMessageWrapperHidden: 'product-form__error-message-wrapper--hidden',
            activeClass: 'active-thumb'
        };

            const btnOriginalContent = $add_to_cart.html();
            console.log(btnOriginalContent);
            $add_to_cart.html("<div class='message'>Added!</div>");
//             $btn.parent().parent().remove();
            setTimeout(function(){
              $add_to_cart.html(btnOriginalContent);
              
             
              
            }, 2000);
          
          
            updateCartCount();
          	// Envision - disable cart popup when replacement cart drawer is enabled
            if (typeof window.SETTINGS !== 'undefined' && typeof window.SETTINGS.ENABLE_CART_DRAWER !== 'undefined') {
              if (window.SETTINGS.ENABLE_CART_DRAWER == false) {
                this._setupCartPopup(data);
              } else {
                $(document).find('.site-header__cart-toggle').trigger('click');
              }
            } else {
              // this._setupCartPopup(data);
            }
			},_setupCartPopup: function(item) {
            this.$cartPopup = this.$cartPopup || $(this.selectors.cartPopup);
            this.$cartPopupWrapper = this.$cartPopupWrapper || $(this.selectors.cartPopupWrapper);
            this.$cartPopupTitle = this.$cartPopupTitle || $(this.selectors.cartPopupTitle);
            this.$cartPopupProperty = this.$cartPopupProperty || $(this.selectors.cartPopupProperty), 
            this.$cartPopupQuantity = this.$cartPopupQuantity || $(this.selectors.cartPopupQuantity);
            this.$cartPopupQuantityLabel = this.$cartPopupQuantityLabel || $(this.selectors.cartPopupQuantityLabel);
            this.$cartPopupClose = this.$cartPopupClose || $(this.selectors.cartPopupClose);
            this.$cartPopupDismiss = this.$cartPopupDismiss || $(this.selectors.cartPopupDismiss);
            this.$cartPopupImagePlaceholder = this.$cartPopupImagePlaceholder || $(this.selectors.cartPopupImagePlaceholder);
            this._setupCartPopupEventListeners();
            this._updateCartPopupContent(item);
        },
        _updateCartPopupContent: function(item) {
//           if(typeof window.BOLD !== 'undefined'

//              && typeof window.BOLD.common !== 'undefined'

//              && typeof window.BOLD.common.cartDoctor !== 'undefined') {

//             // NOTE: "item" should be the variable containing the item json data from the cart/add.js response

//             item = window.BOLD.common.cartDoctor.fixItem(item);
//           }
             var recurring_desc = "";

            if(item.properties_all  && item.properties_all.frequency_num){

              recurring_desc = "<span> Delivered Every " + item.properties_all.frequency_num + " " + item.properties_all.frequency_type_text + " " + item.properties_all.discounted_price + " each" + "</span>"; 

            }
            var quantity = 1 ;
            this.$cartPopupTitle.text(item.product_title);
            this.$cartPopupProperty.html(recurring_desc),
            this.$cartPopupQuantity.text(quantity);
            this.$cartPopupQuantityLabel.text(theme.strings.quantityLabel.replace('[count]', quantity));
            this._setCartPopupPlaceholder(item.featured_image.url, item.featured_image.aspect_ratio);
            this._setCartPopupImage(item.featured_image.url, item.featured_image.alt);
            this._setCartPopupProductDetails(item.product_has_only_default_variant, item.options_with_values, item.properties);
            $.getJSON('/cart.js').then(function(cart) {
//                if(typeof window.BOLD !== 'undefined'

//                  && typeof window.BOLD.common !== 'undefined'

//                  && typeof window.BOLD.common.cartDoctor !== 'undefined') {

//                 // NOTE: "cart" should be the variable containing the cart json data

//                 cart = window.BOLD.common.cartDoctor.fix(cart);

//               }
                this._setCartQuantity(cart.item_count);
                this._setCartCountBubble(cart.item_count);
                this._showCartPopup();
            }
            .bind(this));
        },
        _setupCartPopupEventListeners: function() {
            this.$cartPopupWrapper.on('keyup', function(event) {
                if (event.keyCode === slate.utils.keyboardKeys.ESCAPE) {
                    this._hideCartPopup(event);
                }
            }
            .bind(this));
            this.$cartPopupClose.on('click', this._hideCartPopup.bind(this));
            this.$cartPopupDismiss.on('click', this._hideCartPopup.bind(this));
            $('body').on('click', this._onBodyClick.bind(this));
        },
        _setCartPopupPlaceholder: function(imageUrl, imageAspectRatio) {
            this.$cartPopupImageWrapper = this.$cartPopupImageWrapper || $(this.selectors.cartPopupImageWrapper);
            if (imageUrl === null) {
                this.$cartPopupImageWrapper.addClass(this.classes.hidden);
                return;
            }
            var $placeholder = $(this.selectors.cartPopupPlaceholderSize);
            var maxWidth = 95 * imageAspectRatio;
            var heightRatio = 100 / imageAspectRatio;
            this.$cartPopupImagePlaceholder.css('max-width', maxWidth);
            $placeholder.css('padding-top', heightRatio + '%');
        },
        _setCartPopupImage: function(imageUrl, imageAlt) {
            if (imageUrl === null)
                return;
            this.$cartPopupImageWrapper.removeClass("hide");
            var sizedImageUrl = theme.Images.getSizedImageUrl(imageUrl, '200x');
            var image = document.createElement('img');
            image.src = sizedImageUrl;
            image.alt = imageAlt;
            image.classList.add(this.classes.cartImage);
            image.dataset.cartPopupImage = '';
            image.onload = function() {
                this.$cartPopupImagePlaceholder.addClass(this.classes.hidden);
                this.$cartPopupImageWrapper.append(image);
            }
            .bind(this);
        },
        _setCartPopupProductDetails: function(product_has_only_default_variant, options, properties) {
            this.$cartPopupProductDetails = this.$cartPopupProductDetails || $(this.selectors.cartPopupProductDetails);
            var variantPropertiesHTML = '';
            if (!product_has_only_default_variant) {
                variantPropertiesHTML = variantPropertiesHTML + this._getVariantOptionList(options);
            }
            if (properties !== null && Object.keys(properties).length !== 0) {
                variantPropertiesHTML = variantPropertiesHTML + this._getPropertyList(properties);
            }
            if (variantPropertiesHTML.length === 0) {
                this.$cartPopupProductDetails.html('');
                this.$cartPopupProductDetails.attr('hidden', '');
            } else {
                this.$cartPopupProductDetails.html(variantPropertiesHTML);
                this.$cartPopupProductDetails.removeAttr('hidden');
            }
        },
        _getVariantOptionList: function(variantOptions) {
            var variantOptionListHTML = '';
            variantOptions.forEach(function(variantOption) {
                variantOptionListHTML = variantOptionListHTML + '<li class="product-details__item product-details__item--variant-option">' + variantOption.name + ': ' + variantOption.value + '</li>';
            });
            return variantOptionListHTML;
        },
        _getPropertyList: function(properties) {
            var propertyListHTML = '';
            var propertiesArray = Object.entries(properties);
            propertiesArray.forEach(function(property) {
                if (property[0].charAt(0) === '_')
                    return;
                if (property[1].length === 0)
                    return;
                if (property[0].startsWith('Preorder'))
                  propertyListHTML = propertyListHTML + '<li class="product-details__item product-details__item--property" style="color: #a2252ad4">' + property[1] + '</li>';
                else
                  propertyListHTML = propertyListHTML + '<li class="product-details__item product-details__item--property">' + '<span class="product-details__property-label">' + property[0] + ': </span>' + property[1] + '</li>';
            });
            return propertyListHTML;
        },
        _setCartQuantity: function(quantity) {
            this.$cartPopupCartQuantity = this.$cartPopupCartQuantity || $(this.selectors.cartPopupCartQuantity);
            var ariaLabel;
            if (quantity === 1) {
                ariaLabel = theme.strings.oneCartCount;
            } else if (quantity > 1) {
                ariaLabel = theme.strings.otherCartCount.replace('[count]', quantity);
            }
            this.$cartPopupCartQuantity.text(quantity).attr('aria-label', ariaLabel);
        },
        _setCartCountBubble: function(quantity) {
            this.$cartCountBubble = this.$cartCountBubble || $(this.selectors.cartCountBubble);
            this.$cartCount = this.$cartCount || $(this.selectors.cartCount);
            this.$cartCountBubble.removeClass(this.classes.hidden);
            this.$cartCount.text(quantity);
        },
        _showCartPopup: function() {
            this.$cartPopupWrapper.removeClass(this.classes.cartPopupWrapperHidden);
            this._handleButtonLoadingState(false);
            slate.a11y.trapFocus({
                $container: this.$cartPopupWrapper,
                $elementToFocus: this.$cartPopup,
                namespace: 'cartPopupFocus'
            });
        },
        _hideCartPopup: function(event) {
            var setFocus = event.detail === 0 ? true : false;
            this.$cartPopupWrapper.addClass(this.classes.cartPopupWrapperHidden);
            $(this.selectors.cartPopupImage).remove();
            this.$cartPopupImagePlaceholder.removeClass(this.classes.hidden);
            slate.a11y.removeTrapFocus({
                $container: this.$cartPopupWrapper,
                namespace: 'cartPopupFocus'
            });
            if (setFocus)
                this.$previouslyFocusedElement[0].focus();
            this.$cartPopupWrapper.off('keyup');
            this.$cartPopupClose.off('click');
            this.$cartPopupDismiss.off('click');
            $('body').off('click');
        },
        _onBodyClick: function(event) {
            var $target = $(event.target);
            if ($target[0] !== this.$cartPopupWrapper[0] && !$target.parents(this.selectors.cartPopup).length) {
                this._hideCartPopup(event);
            }
        },
        _handleButtonLoadingState: function(isLoading) {
            if (isLoading) {
                $add_to_cart.attr('aria-disabled', true);
            } else {
                $add_to_cart.removeAttr('aria-disabled');
            }
        }
         });

//   <<<<<< OC >>>>>>
//       $.post("/cart/add", {quantity: 1, id: pid, add: true}, function(data){
//         $add_to_cart.html("<div class='message'>Added!</div>");
//         $btn.parent().parent().remove();
//       }).then(updateCartCount);
      
    }else{
		console.log("trigger bis button");
      var product_handle = $(this).data("p-handle");
//       $(this).parent().parent().next(".hideme_for_variants").find("a.klaviyo-bis-trigger").data("klaviyo-handle");
      $("a[data-klaviyo-handle='"+product_handle+"']")[0].click(); 
	}
    });
  
  // $(document).on("click", ".product-recommendations__inner .overlay-product-options ul li", function(){
    
  //     var pid = $(this).attr('value');
  //     var $btn = $(this);
  //    var $add_to_cart = $(this).parent().parent().prev();
  //   console.log('pid: '+pid);
  //     $.post("/cart/add", {quantity: 1, id: pid, add: true}, function(data){
  //       $add_to_cart.html("<div class='message'>Added!</div>");
  //       $btn.parent().parent().remove();
  //     }).then(updateCartCount);
  //   });

    $('.add-varitial-to-cart-btn').on("click", function(){
      var pid = $(this).data('id');
      var vid = $("select.product-"+pid).val();
      var $btn = $(this);
      $.post("/cart/add", {quantity: 1, id: vid, add: true}, function(data){
        $btn.parent().html("<div class='message'>Added!</div>");
        $btn.remove();
      }).then(updateCartCount);
    });

    $('#SingleOptionSelector-0').on('change', function(){
      console.log($(this).find(':selected').data('available'));
    });
  };

  if ((typeof jQuery === 'undefined') || (parseFloat(jQuery.fn.jquery) < 1.7)) {
    loadScript('//ajax.googleapis.com/ajax/libs/jquery/1.9.1/jquery.min.js', function(){
      jQuery191 = jQuery.noConflict(true);
      myAppJavaScript(jQuery191);
    });
  } else {
//     console.log(jQuery('.add-to-cart-overlay'))
    myAppJavaScript(jQuery);
  }
})()
